import { fetchClient } from './fetchClient';

export interface ArticleResponse {
    id: number;
    title: string;
    cover_image: string;
    content: string;
    expert_name?: string;
    expert_specialty?: string;
    expert_avatar_url?: string;
}

export const getArticle = async (articleId: string | undefined): Promise<ArticleResponse> => {
    if (!articleId) {
        throw new Error('Article ID is required');
    }

    const response = await fetchClient(`/non-workout-content/articles/${articleId}`);

    return response.json();
};
